import './opcode.svelte.css';
/* src/components/opcode.svelte generated by Svelte v3.43.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "../../_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher } from '../../_snowpack/pkg/svelte.js';

function create_fragment(ctx) {
	let div2;
	let div0;
	let t0_value = /*code*/ ctx[0].operation + "";
	let t0;
	let t1;
	let div1;
	let t2;
	let mounted;
	let dispose;

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			t0 = text(t0_value);
			t1 = space();
			div1 = element("div");
			t2 = text(/*name*/ ctx[1]);
			attr(div0, "class", "code svelte-1f4u06s");
			attr(div1, "class", "name");
			attr(div2, "class", "opcode svelte-1f4u06s");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			append(div0, t0);
			append(div2, t1);
			append(div2, div1);
			append(div1, t2);

			if (!mounted) {
				dispose = listen(div2, "click", /*click_handler*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*code*/ 1 && t0_value !== (t0_value = /*code*/ ctx[0].operation + "")) set_data(t0, t0_value);
			if (dirty & /*name*/ 2) set_data(t2, /*name*/ ctx[1]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div2);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let name;
	const dispatch = createEventDispatcher();
	let { code = 'push' } = $$props;
	const click_handler = () => dispatch('op', code);

	$$self.$$set = $$props => {
		if ('code' in $$props) $$invalidate(0, code = $$props.code);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*code*/ 1) {
			$: $$invalidate(1, name = code.name.toUpperCase());
		}
	};

	return [code, name, dispatch, click_handler];
}

class Opcode extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { code: 0 });
	}
}

export default Opcode;